import CityPageTemplate from "../city-template/CityPageTemplate";
import { butteConfig } from "./data";

export default function ButtePage() {
  return <CityPageTemplate config={butteConfig} />;
}